import { useGetOfferSlotsQuery } from '../api';

/**
 * Hook para obtener los slots de una oferta.
 * Uso: const { slots, isLoading } = useOfferSlots(offerId)
 */
export function useOfferSlots(offerId: string | undefined) {
  const { data, isLoading, isError, error, refetch } = useGetOfferSlotsQuery(
    { offer_id: offerId! },
    { skip: !offerId }
  );

  return {
    slots: data ?? [],
    isLoading,
    isError,
    error,
    refetch,
  };
}
